<template>
  <div
    :id="my.gid+'_'+my.email"
    :key="my.gid+'_'+my.email"
  >
    <div
      class="flex-row-center"
    >
      <div
        v-if="prefix"
        class="mr-1"
      >
        {{ prefix }}
      </div>
      <img
        v-if="my.email"
        ref="showActivator"
        :src="my.avatar"
        class="pointer"
        :style="{
          'height': avatarsize + 'px',
          'width': avatarsize + 'px',
          'margin': '0 4px 0 0',
        }"
        @click.stop="clickAvatar()"
      >
      <div
        :style="{
          'font-size': textsize + 'px',
        }"
      >
        {{ my.name }}
      </div>
      <div
        v-if="ending"
        class="ml-1"
      >
        {{ ending }}
      </div>
    </div>
  </div>
</template>

<script>
  // # ms - new file
  // clean version - do nothing sync google or microsoft
  import { mapState } from 'vuex'
  // import { xPost } from '@/http/axios'
  // import md5 from '@/functions/md5'

  export default {
    name: 'PoptipProfile',
    props: {
      useremail: {
        type: String,
        default () {
          return ''
        }
      },
      username: {
        type: String,
        default () {
          return ''
        }
      },
      gid: {
        type: String,
        default () {
          return ''
        }
      },
      avatarsize: {
        type: Number,
        default () {
          return 16
        }
      },
      textsize: {
        type: Number,
        default () {
          return 14
        }
      },
      url: {
        type: String,
        default () {
          return require('@/assets/avatar.png')
        }
      },
      prefix: {
        type: String,
        default () {
          return ''
        }
      },
      ending: {
        type: String,
        default () {
          return ''
        }
      }
    },
    data () {
      return {
        show: false,
        loading: true,
        defaultURL: require('@/assets/avatar.png'),

        // actually displayed
        my: {
          gid: null,
          email: null,
          name: null,
          avatar: null
        }
      }
    },

    computed: {
      ...mapState([
        'userInfo',
        'msal'
      ])
    },
    watch: {
      gid (nv, ov) {
        if (nv !== ov) {
          this.init()
        }
      },
      useremail (nv, ov) {
        if (nv !== ov) {
          this.init()
        }
      },
      username (nv, ov) {
        if (nv !== ov) {
          this.init()
        }
      },
      url (nv, ov) {
        if (nv !== ov) {
          this.init()
        }
      }
    },
    beforeMount () {
      this.init()
    },

    methods: {
      // mouseleaveTag () {
      //   this.show = false
      // },
      clickAvatar () {
        if (this.gid) {
          console.info('clickAvatar: ' + this.gid)
          this.$router.push({ path: '/user/' + this.gid })
        }
      },
      init () {
        this.my.gid = this.gid
        this.my.email = this.useremail
        this.my.name = this.username
        this.my.avatar = this.url || this.defaultURL
        // this.syncGoogle()
      },

      // async syncGoogle (timeoftry) {
      //   try {
      //     const gapi = await this.$gapi.getGapiClient()
      //     const res = await gapi.client.directory.users.get({
      //       userKey: (this.gid || this.useremail || '').toString().trim(),
      //       viewType: 'domain_public',
      //       projection: 'full'
      //     })
      //     if (res.result && res.status === 200) {
      //       const gid = res.result.id || null
      //       const email = res.result.primaryEmail || null
      //       const name = res.result.name.fullName || null
      //       const avatar = res.result.thumbnailPhotoUrl || null
      //       if (!this.cmpInfo(gid, email, name, avatar)) {
      //         // update display
      //         this.my.gid = gid
      //         console(this.my.gid)
      //         this.my.email = email
      //         this.my.name = name
      //         this.my.avatar = avatar || this.defaultURL
      //         // sync database
      //         // this.postSyncUser()
      //       }
      //     }
      //     // else {
      //     //   throw new DOMError({
      //     //     detail: 'response error',
      //     //     status: res.status,
      //     //   })
      //     // }
      //   } catch (error) {
      //     // console.log(error)
      //     if (timeoftry < this.maxLoadingTime) {
      //       setTimeout(() => {
      //         this.syncGoogle(timeoftry + 1)
      //       }, 1000)
      //     }
      //   }
      // },

      // function
      cmpInfo (gid, email, name, avatar) {
        const url = this.url === '' ? null : this.url
        return (
          this.gid === gid &&
          this.useremail === email &&
          this.username === name &&
          url === avatar
        )
      }

      // post server request
      // async postSyncUser () {
      //   try {
      //     const token = Number(new Date())
      //     const passcode = md5(['syncuser', token])

      //     const req = xPost(
      //       'users',
      //       'sync',
      //       {
      //         u: this.userInfo,
      //         t: token,
      //         p: passcode,
      //         x: this.my,
      //       })
      //     const res = await req
      //   } catch (err) {
      //     console.log('[Error - Sync User]')
      //   // debug
      //   // console.log(err)
      //   }
      // },
    }
  }
</script>

<style>
  .pointer {
    cursor: pointer;
    border-radius: 50%;
  }
  .xs-avatar {
    height: 20px;
    width: 20px;
    border-radius: 50%;
  }
  .sm-avatar {
    height: 24px;
    width: 24px;
    border-radius: 50%;
  }
  .md-avatar {
    height: 40px;
    width: 40px;
    border-radius: 50%;
  }
  .flex-row-center {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
</style>
